"use client";

import { getStepStripDesktopShapeClasses } from "./stepStripDesktopShape";

const STEPS = [
  {
    label: "SHOP MENU",
    text: "Browse our legal Calgary weed delivery menu online",
  },
  {
    label: "ADD TO CART",
    text: "Choose flower, vapes, edibles, and more - then add to cart",
  },
  {
    label: "CHECKOUT SECURELY",
    text: "Complete your order online using your credit card",
  },
  {
    label: "WE DELIVER",
    text: "Same-day delivery in 45 minutes with SMS tracking",
  },
] as const;

export default function CalgaryWeedDeliverySection() {
  return (
    <section className="w-full max-w-none" aria-labelledby="calgary-weed-delivery-heading">
      <div className="w-full">
        <div className="grid gap-4 lg:grid-cols-[1fr_1.1fr] lg:items-start lg:gap-8">
          <h2
            id="calgary-weed-delivery-heading"
            className="text-h3-mobile sm:text-h3-desktop font-bold text-text-primary"
          >
            Calgary Weed Delivery
          </h2>
          <p className="text-body-md font-medium leading-relaxed text-text-secondary">
            Dank is your #1 trusted source for fast, friendly and discreet weed delivery service in Calgary.
            It&apos;s never been easier or more affordable to get legal bud delivered right to your doorstep.
            We offer the best legal same day Calgary weed delivery in the game.
          </p>
        </div>
        <div className="relative w-full overflow-x-auto scrollbar-hide">
        {/* min-w-max, not a fixed 1440px: the four cards need 1230px (4x300 plus
            three 10px gaps), so a hardcoded 1440 pushed 210px of nothing past the
            right edge and clipped the fourth step on any normal screen. This is
            exactly as wide as the cards require, and still scrolls below that. */}
        <div className="mt-4 grid grid-cols-4 gap-[10px] min-w-max lg:min-w-0">
          {STEPS.map((step, index) => (
            <article
              key={step.label}
              className={[
                "relative flex flex-col justify-between overflow-hidden rounded-xl border border-blue-10 bg-constant-white pb-4 pl-5 pr-6 pt-3 min-w-[300px] lg:min-w-0 lg:pl-4 lg:pr-5",
                "min-h-40",
                getStepStripDesktopShapeClasses(index, STEPS.length),
              ].join(" ")}
            >
              <span
                className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-[200px] font-black leading-none text-blue-10 select-none"
                aria-hidden
              >
                {index + 1}
              </span>
              <span className="relative inline-block w-max rounded-xl border border-blue-10 bg-blue-5 px-3 py-1 text-body-16-desktop font-medium text-blue-60">
                {step.label}
              </span>
              <p className="relative text-body-20-desktop font-bold leading-snug text-blue-60">
                {step.text}
              </p>
            </article>
          ))}
        </div>
        </div>
      </div>
    </section>
  );
}
